import {lazy} from 'react';
import GenericFallbackSuspense from '../../../../../../v2/components/ui/GenericFallback/GenericFallbackSuspense';

const SpotiiOverlayBody = lazy(() => import('./SpotiiOverlayBody'/* webpackChunkName: 'SpotiiOverlayBody' */));

export default function SpotiiOverlayLazyLoader() {
  return (
    <GenericFallbackSuspense>
      <SpotiiOverlayBody />
    </GenericFallbackSuspense>
  );
}
